<template>
  <div>
    <el-dialog v-model="setCoursePlanShow" title="Tips" width="500" :show-close="false" :align-center="true">
      <template #header>
        <div class="header">更换方案</div>
        <div class="close_icon" @click="closePopup">
          <el-icon :size="20">
            <CloseBold />
          </el-icon>
        </div>
      </template>
      <div class="dialog_content px-30">
        <div class="flex Flexalilgn">
          <el-image class="courseCoverImg" :src="courseInfo.courseCoverImg"></el-image>
          <div class="course_info flex flexcolumn FlexBetween flex-1 ml-20">
            <div class="toverflows toverflow2 course_name">{{ courseInfo.courseName }}</div>
            <div class="flex Flexalign plan_select">
              <div class="mr-15">课程方案</div>
              <el-select v-model="planValue" placeholder="Select" size="large" style="width: 120px">
                <el-option v-for="item in planList" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </div>
          </div>
        </div>
        <div class="btn_box flex FlexEvenly mt-20">
          <div class="btn cursor_pointer" @click="closePopup">取消</div>
          <div class="btn btn_confirm" @click="changeCourseScheme">确定</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "GjkcH5NoWrong",
  components: {},
  computed: {
    ...mapState({
      courseScheme: (state) => state.learning.courseScheme,
    }),
  },

  data() {
    return {
      setCoursePlanShow: false,
      planList: [
        // { label: "基础", value: 1 },
        // { label: "强化", value: 2 },
        // { label: "拔尖", value: 3 },
        // { label: "冲刺", value: 4 },
      ],
      planValue: 1,
      courseId: "",
      courseInfo: {},
    };
  },

  mounted() {
    // this.getSchemeByCourseId();
    this.planValue = this.courseScheme;
  },

  methods: {
    closePopup() {
      this.setCoursePlanShow = false;
    },
    // 获取课程方案列表
    getSchemeByCourseId() {
      this.planList = [];
      this.$Api.course
        .getSchemeByCourseId(this.courseId)
        .then((res) => {
          res.data.data.forEach((item) => {
            this.planList.push({
              label: item.schemeName,
              value: item.schemeId,
            });
          });
        })
        .catch(() => { });
    },
    changeCourseScheme() {
      this.$store.commit("learning/setCourseScheme", this.planValue);
      this.$Api.course.changeCourseScheme({ courseId: this.courseId, schemeId: this.planValue }).then(() => {
        this.$Dialog.toast("方案切换成功", { type: "success" });
        setTimeout(() => {
          this.closePopup();
          this.$emit("getMyCourseList");
        }, 500);
      }).catch(() => { })
    },
  },
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog) {
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  padding: 0;
  width: 507px;
  height: 256px;
  position: relative;
}

:deep(.el-dialog__header) {
  position: relative;
  padding: 0 20px;
  box-sizing: border-box;
  text-align: start;
}

.header {
  //   text-align: center;
  //   font-weight: bold;
  font-size: 20px;
  color: #333333;
  line-height: 60px;
  // border-bottom: 1px solid rgba(36, 35, 36, 0.1);
}

.close_icon {
  position: absolute;
  top: 20px;
  right: 20px;
  color: #333333;
}

.dialog_content {
  .courseCoverImg {
    width: 180px;
    height: 115px;
    border-radius: 10px;
  }
  .course_info{
    height: 115px;
    .course_name{
      color: #101010;
    }
  }

  .plan_select {
    color: #111111;
  }

  .btn_box {
    .btn {
      width: 98px;
      height: 35px;
      border-radius: 10px;
      border: 1px solid #13d6aa;
      line-height: 35px;
      text-align: center;
      color: #13d6aa;
    }

    .btn_confirm {
      color: #fff;
      background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
    }
  }
}
</style>